import { Button, Card, Col, Row } from '@pankod/refine-antd';
import { AppInstanceSelectCard } from 'components/app-setup';
import { AppInstanceCreateModal } from 'components/modal';
import { useState } from 'react';
import useAppInstanceStore from 'store/useAppInstanceStore';

const AppSetupShow: React.FC = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { appInstances } = useAppInstanceStore();

  return (
    <>
      <AppInstanceCreateModal
        isModalOpen={isCreateModalOpen}
        closeModal={() => setIsCreateModalOpen(false)}
      />

      <Row gutter={[12, 12]}>
        {/* App Instance Selection Cards*/}
        {appInstances.map((app) => (
          <Col key={app.id}>
            <AppInstanceSelectCard id={app.id} name={app.displayName} />
          </Col>
        ))}

        {/* App Instance  Creation Card */}
        <Col>
          <Card style={{ width: '250px' }}>
            <div
              style={{
                border: '1px dashed #dee0e2',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '1.5rem',
                borderRadius: '3px',
              }}
            >
              <Button onClick={() => setIsCreateModalOpen(true)}>Create New</Button>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AppSetupShow;
